/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_freeGlobal.js
// module id = 587
// module chunks = 3 4 5 6 9 13 15